<div class="header-mainInfo">
    <a class="control-item" href="/estudio" title="Ir a estudio">Estudio</a><span
        class="header-mainInfo__separator">/</span>
    <h1 class="">Mapa curricular</h1>
    <span class="spacer"></span>
</div>
